import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BranchesGridDataService } from 'common/services/data-services/admin/branches/branches-grid-data.service';
import { BranchesModel } from 'common/models/page-models/Branches/branches-data-model';
import { BranchesGridMetaModel } from 'common/models/page-models/Branches/branches-grid-meta-model';
import { BranchesListingModel } from 'common/models/page-models/Branches/branches-grid-model';
 
@Injectable({
    providedIn: 'root'
})
export class BranchesGridWidgetService extends GridWidgetService<BranchesModel, BranchesListingModel> {
    constructor(protected override ds: BranchesGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new BranchesGridMetaModel().getMetaModel();
        return meta;
    }
}